import { getFirestore, doc, updateDoc } from 'firebase/firestore/lite';
import moment from 'moment';
import app from '../firebase';
import { firebaseCollection } from '../constants';

const db = getFirestore(app);

export async function deleteMessage(classId, messageId) {
  const messageRef = doc(db, `${firebaseCollection.CHAT_MESSAGE}${classId}`, messageId);
  await updateDoc(messageRef, {
    isDeleted: true,
    updatedAt: moment.now()
  });
  return messageRef;
}
